export default __webpack_public_path__ + "static/media/logo1.59c4cd0d.png";